import styles from '@styles/screens/StartDemoScreen.module.css'
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';
import { isMobile } from 'react-device-detect';
import { HorizontalContainer, VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { H2Title, Subtitle } from "@components/General/Titles"
import { ErrorText, Text } from "@components/General/Texts"
import designSystem from "@styles/designSystem"
import { useLocation } from 'react-router-dom';
import { QontactLogoPanel } from '@components/QontactLogoPanel';
import { useValidateNumberViewModel } from '../view-models/ValidateNumberScreenViewModel';
import { TextInput } from '@components/General/TextInput';
import { NormalButton } from '@components/General/Button';
import { useEffect } from 'react';

export const ValidateNumberScreen: React.FC = () => {
    const {
        loading,
        name,
        phone,
        company,
        code,
        codeError,
        setLoading,
        setCode,
        serviceError,
        handleSubmit,
        viewDidAppear
    } = useValidateNumberViewModel();
    // viewDidAppear - runs only once when component first mounts
    useEffect(() => {
        viewDidAppear()
    }, []) // Empty dependency array ensures this runs only once

    return (
        <HorizontalContainer            
            gap={designSystem.gapNone}
            height={'100%'}
        >
            <VerticalContainer 
                maxWidth={'50%'} 
                height={'100%'}
            >
                <QontactLogoPanel/>
            </VerticalContainer>
            <VerticalContainer 
                maxWidth={'50%'} 
                alignment={'center'}
                backgroundColor={designSystem.colorBackgroundGray3}
            >
                <VerticalSpacer/>
                <VerticalContainer 
                    width={'600px'}
                >
                    <VerticalContainer gap={designSystem.gapNone}>
                        <H2Title text={"Validar Número".localized()}/>
                        <Subtitle text={`Hola %s, vamos a validar tu número de teléfono`.localized(name)}/>
                    </VerticalContainer>
                    <Text text={"Escribí el código exactamente como aparece, te lo enviamos por **WhatsApp** al %s".localized(phone)} markdown={true}/>
                    <TextInput
                        label=""
                        placeholder=""
                        onChange={(e) => {setCode(e)}}
                        onEnterPress={() => { handleSubmit() }}
                        value={code}
                        error={codeError}
                    />
                    <NormalButton 
                        text={"Siguiente".localized()}
                        width={"300px"}
                        onClick={() => {
                            handleSubmit()
                        }} 
                        loading={loading}
                    />
                    { serviceError && 
                        <ErrorText text={serviceError}/>
                    }
                </VerticalContainer>
                <VerticalSpacer/>
            </VerticalContainer>
        </HorizontalContainer>
    )    
}